var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.favorite)?_c('div',{attrs:{"id":"favorite-tab"}},[_c('FavoriteEditionForm',{ref:"form",attrs:{"favorite":_vm.favorite,"categories":_vm.categories},on:{"edit":function($event){return _vm.$emit('edit', $event)},"delete":function($event){return _vm.$emit('delete', $event)}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }